/** @format */

import { IntlShape } from 'gatsby-plugin-intl';
import kebabCase from 'lodash/kebabCase';
import { CITIES, MINOR_CITIES } from '../../@ducks/locations/constants';
import { isValidTranslationString } from '../../i18n/utils/check-valid-translation';
import { deprecatedUrlSanitizer } from './url-sanitizer';

export default function calculateListingUrl(
  city: string,
  intl: IntlShape,
  sortBy?: 'all' | 'building' | 'shared_apartment',
  poi: string = '',
  paginate: number = 1,
) {
  let plp_city;
  const lowecaseName = !!city ? city.toLocaleLowerCase().replaceAll(' ', '_') : '';

  if (lowecaseName === '') {
    console.warn('[calculate-listing-url] NO CITY PASSED, FALLBACK TO MILAN');
    plp_city = intl.formatMessage({ id: 'milan' });
  }

  const parametersPoi = poi !== '' ? `${poi}/` : '';
  const parametersPaginate = paginate !== 1 ? `${paginate}/` : '';

  if (!isValidTranslationString(lowecaseName)) plp_city = lowecaseName;
  else plp_city = intl.formatMessage({ id: getPLPCityNameFromUnformattedName(lowecaseName) }).toLowerCase();

  const url = [intl.formatMessage({ id: 'plp_url_rent_room' }), kebabCase(plp_city)].join('-');
  const parameters = [
    sortBy && sortBy !== 'all' ? `sort-by=${sortBy === 'building' ? 'building' : 'shareapp'}` : undefined,
  ].filter(Boolean);

  if (parameters.length > 0) {
    return [`${deprecatedUrlSanitizer([url].join('/'))}/`, parameters.join('&')].join('?');
  }
  return `${deprecatedUrlSanitizer(url)}/${parametersPoi}${parametersPaginate}`;
}

export const getPLPCityNameFromUnformattedName = (name: string): string => {
  const isMajorCity = !!CITIES.find(city => city.name === name);
  if (isMajorCity) return name;

  return MINOR_CITIES.find(city => city.name === name)?.belongs_to as string;
};
